import { Tab, Tooltip } from "@mui/material";
import React from "react";
import { IListFilterItem } from "../../../../models/common/listFilterItem";
import * as Styled from "./FilterTabs.styles";

interface FilterTabsProps {
    items: IListFilterItem[];
    standardFilters: IListFilterItem[];
    selectedId?: string;
    selectedSavedId?: string;
    onSetActiveItem: (reportId: string) => void;
    onSetActiveStandardItem: (reportId: string) => void;
}

export const FilterTabs = ({ items, standardFilters, selectedId, selectedSavedId, onSetActiveItem, onSetActiveStandardItem }: FilterTabsProps) => {
    return (
        <Styled.Tabs
            variant="scrollable"
            scrollButtons="auto"
            value={selectedId || selectedSavedId}
            sx={{
                ".MuiTabScrollButton-root.Mui-disabled": {
                    display: "none"
                }
            }}
            TabScrollButtonProps={{
                color: "primary",
                sx: { border: "1px solid rgba(40, 86, 183, 0.5)", borderRadius: ".5rem" },
            }}
        >
            {(standardFilters && standardFilters.length) && standardFilters.map(item => (
                <Tab key={item.id} value={item.id} label={item.title} onClick={() => onSetActiveStandardItem(item.id)} />
            ))}
            {(items && items.length) && items.map(item => (
                <Tab key={item.id} value={item.id} label={item.title.length > 20 ? <Tooltip title={item.title}><Styled.TabLabel>{item.title}</Styled.TabLabel></Tooltip> : item.title} onClick={() => onSetActiveItem(item.id)} />
            ))}
        </Styled.Tabs>
    );
};
